import moment from 'moment';
import React from 'react';
import { useIntl } from 'react-intl';

import { Notification, Title } from '@xsolla/ui-core';
import { AlertExclamationColorful } from '@xsolla/ui-icons';
import { Modal } from '@xsolla/ui-modal';

import { BanOptions } from '../../../../api/users/types';
import { TextLeftBlock } from '../../../../styled';
import { HumanIcon } from '../../../ui';
import { ModalBanFields } from './ModalBanFields';
import {
  AlertIconWrapper,
  BanUserSubtitle,
  ModalWrapper,
  NotificationDescription,
  NotificationTitle
} from './style';

type Props = {
  userId: string;
  projectId: string;
  registered: string;
  externalId: string | null;
  banData: BanOptions | null;
  onBan: (banData: BanOptions) => void;
  onClose: () => void;
};

export const BanUserModal = ({
  externalId,
  banData,
  registered,
  onBan,
  userId,
  projectId,
  onClose
}: Props): JSX.Element => {
  const intl = useIntl();

  return (
    <Modal>
      <ModalWrapper>
        <AlertIconWrapper>
          <AlertExclamationColorful size={40} />
        </AlertIconWrapper>
        <Title center indent="sm" data-test-id="user-ban-modal-header">
          {intl.formatMessage({ id: 'users.list-block.table.ban-modal.title' })}
        </Title>
        <BanUserSubtitle>
          {intl.messages['users.list-block.table.ban-modal.subtitle']}
        </BanUserSubtitle>
        <Notification icon={HumanIcon}>
          <TextLeftBlock>
            <NotificationTitle>
              {intl.messages['users.list-block.table.ban-modal.profile.title']}
            </NotificationTitle>
            <NotificationDescription>ID {userId}</NotificationDescription>
            {externalId && (
              <NotificationDescription>
                {intl.formatMessage(
                  { id: 'users.list-block.table.ban-modal.profile.external-id' },
                  { id: externalId }
                )}
              </NotificationDescription>
            )}
            <NotificationDescription>
              {intl.formatMessage(
                { id: 'users.list-block.table.ban-modal.profile.register-date' },
                { date: moment(registered).format('L LT') }
              )}
            </NotificationDescription>
          </TextLeftBlock>
        </Notification>
      </ModalWrapper>
      <ModalBanFields
        projectId={projectId}
        userId={userId}
        onBan={onBan}
        onClose={onClose}
        banData={banData}
      />
    </Modal>
  );
};
